import { Flex, theme, Typography, Button } from 'antd'
import { ShareAltOutlined } from '@ant-design/icons'
import { useGetMoneyFlow, useUpdateDocument } from '../api/case/document.ts'
import { useParams } from "react-router-dom"
import { EditOutlined } from "@ant-design/icons"
import { MoneyFlowControls } from "./MoneyFlowControls.tsx"
import { ReportControls } from "./Report/ReportControls.tsx"
import { useGetReport } from "../api/report/report.ts"
import { CONTROL_HEIGHT } from "../utils/constants.ts"
import { ShareMoneyFlowModal } from '../modals/ShareMoneyFlowModal/ShareMoneyFlowModal.tsx'
import { useShareMoneyflowModal } from '../modals/ShareMoneyFlowModal/useShareMoneyFlowModal.ts'

export const DocumentControls = () => {
    const {
        documentId,
        reportId
    } = useParams()
    /*const navigate = useNavigate()*/
    const { data: moneyflow } = useGetMoneyFlow(documentId)
    const { data: report } = useGetReport(reportId)
    // const { mutate: archiveDocument } = useArchiveDocument(caseId!)
    const { mutate: updateDocument } = useUpdateDocument()
    const { show } = useShareMoneyflowModal()
    const document = moneyflow || report?.data
    const { token } = theme.useToken()

    const handleDocumentNameChange = (value: string) => {
        updateDocument({
            contentType: document!.contentType,
            changes: { name: value },
            documentId: documentId || reportId as string,
        })
    }

    return (
        <Flex
            style={{
                backgroundColor: token.colorBgContainer,
                height: CONTROL_HEIGHT,
                paddingInlineStart: token.paddingMD,
                paddingInlineEnd: token.paddingMD,
                gap: token.margin
            }}
            gap={token.marginSM}
            align="center"
        >
            {documentId && <Button
                style={{ marginRight: 'auto' }}
                icon={<ShareAltOutlined />}
                onClick={() => show()}
            />}
            <Typography.Title
                editable={{
                    icon: <EditOutlined style={{ fontSize: "20px" }} />,
                    onChange: handleDocumentNameChange,
                    autoSize: { maxRows: 1 }
                }}
                level={4}
                ellipsis
                style={{
                    margin: 0,
                    minWidth: '100px',
                    flexGrow: 1
                }}
            >
                {document?.name}
            </Typography.Title>
            {moneyflow && <ShareMoneyFlowModal />}
            {documentId && <MoneyFlowControls />}
            {reportId && <ReportControls />}
        </Flex>
    )
}
